import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  apis: [
    {
      type: "file",
      input: "./openapi.yml",
      path: "/docs",
      options: { 
        schemaDownload: { enabled: true },
        expandApiInformation: true,
        disablePlayground: true
      }
    },
  ],
  docs: {
    files: '/pages/**/*.{md,mdx}',
    publishMarkdown: true,
    defaultOptions: {
      copyPage: false,
      showLastModified: false
    },
    llms: {
      llmsTxt: true,
      llmsTxtFull: true,
      includeProtected: true
    }
  },
  navigation: [
    { type: 'link', label: 'Getting Started', to: '/introduction', icon: 'home' },
    { type: 'category', label: 'Access', icon: 'key', items: [
      { type: 'link', label: 'Request Access', to: '/request-access', icon: 'plus-circle' },
      { type: 'link', label: 'Authentication', to: '/authentication', icon: 'lock' },
    ]},
    { type: 'category', label: 'Guides', icon: 'book', items: [
      { type: 'link', label: 'Quickstart', to: '/guides/quickstart', icon: 'play' },
      { type: 'link', label: 'Authentication', to: '/guides/auth-guide', icon: 'lock' },
      { type: 'link', label: 'Pagination & Filtering', to: '/guides/pagination-filtering', icon: 'columns' },
      { type: 'link', label: 'Rate Limits', to: '/guides/rate-limits', icon: 'clock' },
      { type: 'link', label: 'Endpoint Examples', to: '/guides/examples-endpoints', icon: 'code' },
      { type: 'link', label: 'POES Guide', to: '/poes', icon: 'satellite' },
      { type: 'link', label: 'GOES Guide', to: '/goes', icon: 'satellite' },
    ]},
    { type: 'link', label: 'API Reference', to: '/docs', icon: 'code' },
  ],
  redirects: [
    { from: '/', to: '/introduction' }
  ],
  metadata: {
    title: "Mission Space API Documentation",
    description: "Space weather data and atmospheric model API providing solar wind, geomagnetic indices, satellite measurements, and atmospheric models",
    favicon: "/favicon.ico",
  },
  site: {
    title: "Mission Space API",
    logo: {
      src: {
        "dark": "/logo-dark.svg",
        "light": "/logo.svg"
      },
      width: "99px"
    },
  },
  search: {
    type: "pagefind"
  }
};

export default config;
